<template>
  <div class="sub-container">
    <v-card class="ml-3 mt-3" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">mdi-account</v-icon>All Templates</span
        >
        <v-spacer />

        <v-btn
          color="purple"
          variant="flat"
          class="btn-text mr-3"
          size="small"
          :to="{ name: 'addTemplate' }"
        >
          <span class="btn-text"
            ><v-icon class="mx-2">mdi-file-plus</v-icon>Add Template</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card variant="flat" class="ml-3">
      <v-card-actions class="ml-8">
        <v-spacer />
        <div class="search-field">
          <v-text-field
            v-model="search"
            label="Quick Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            hide-details
            single-line
          />
        </div>
      </v-card-actions>
      <v-data-table
        :items="templates.length > 0 ? templates : []"
        :headers="headers"
        item-value="id"
        :search="search"
         density="compact"
        :items-per-page="17"
        class="mx-3"
      >
        <template #[`item.status`]="{ item }">
          <v-chip
            :color="getColor(item.raw.is_subscribed)"
            variant="flat"
            size="x-small"
          >
            <span class="chip-text">{{
              item.raw.is_subscribed ? "subscribed" : "unsubscribed"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.created_at`]="{ item }">
          <span>
            {{ item.raw.created_at ? formatTime(item.raw.created_at) : "N/A" }}
          </span>
        </template>

        <template #[`item.updated_at`]="{ item }">
          <span>
            {{ item.raw.updated_at ? formatTime(item.raw.updated_at) : "N/A" }}
          </span>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center">
            <!-- View -->
            <v-tooltip location="bottom" text="View">
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  class="cursor-pointer text-info mx-2"
                  @click="viewItem(item.raw.content)"
                >
                  mdi-eye
                </v-icon>
              </template>
            </v-tooltip>

            <!-- Edit -->
            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  class="cursor-pointer text-primary mx-2"
                  @click="
                    $router.push({
                      name: 'addTemplate',
                      params: { id: item.raw.id },
                    })
                  "
                >
                  mdi-pencil
                </v-icon>
              </template>
            </v-tooltip>

            <!-- Delete -->
            <v-tooltip location="bottom" text="Delete">
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  class="cursor-pointer text-error mx-2"
                  @click="deleteItem(item.raw.id, item.raw.name)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
  <v-dialog v-model="loaderState" max-width="500">
    <v-card>
      <v-card-actions><v-spacer />Please Wait <v-spacer /></v-card-actions>
      <v-card-actions
        ><v-spacer />
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>

        <v-spacer />
      </v-card-actions>

      <v-progress-linear
        class="mx-2 mt-n3"
        color="teal"
        indeterminate
      ></v-progress-linear>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialog">
    <v-card>
      <div v-html="tempPreview"></div>
      <v-card-actions>
        <v-spacer />

        <v-btn
          color="#343a40"
          width="80"
          variant="flat"
          @click="dialog = false"
        >
          <span class="btn-text">Close</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="deleteDialog">
    <v-card>
      <div v-html="tempPreview"></div>
      <v-card-actions>
        <v-spacer />

        <v-btn
          color="#343a40"
          width="80"
          variant="flat"
          @click="dialog = false"
        >
          <span class="btn-text">Close</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { from } from 'core-js/core/array';

export default {
  name: "AllTemplates",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("templates/getTemplates");
    });
  },

  data() {
    return {
      deleteDialog: false,
      groups: [],
      menu: false,
      menu2: false,
      menu3: false,
      search: "",
      isValid: false,
      loadingState: false,
      screenSize: "",
      oldValue: false,
      tempPreview: "",
      dialog: false,

      selected: [],

      headers: [
        { title: "Name", key: "name" },
        { title: "created _at", key: "created_at" },
        { title: "updated _at", key: "updated_at" },
        { title: "Actions", key: "actions" },
      ],
    };
  },

  computed: {
    templates() {
      return this.$store.getters["templates/templatesGetters"]("Templates");
    },

    loaderState() {
      return this.$store.getters["templates/templatesGetters"]("loaderState");
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },

    deleteItem(val, val2) {
      if (confirm(`Are you sure you want to delete template: ${val2}`)) {
        this.$store.dispatch("templates/deleteTemplate", parseInt(val));
      }
    },
    viewItem(val) {
      this.dialog = true;
      this.tempPreview = val;
    },

    getColor(val) {
      if (val) return "#46c35f";
      else return "orange";
    },
    changeAvatarColor(item) {
      // Change the color of the clicked avatar
      item.avatarProps.color = "red"; // Change to desired color
    },
    formatTime(val) {
      const date = new Date(val);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 1-based
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${" "} ${hours}:${minutes}`;
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import url("../templatesStyle.css");
</style>
